/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

export const inlineFormLabelStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.5em;
   .ssp-name {
        display: inline-block;
        margin-right: 2em;
        min-width: 130px;
   } 
    input {
        flex-grow: 1;
    }
`

export const sspDisplayTableStyles = css`
    table-layout: fixed;
    border: 1px solid #d6d6d6;
    width: 100%;
        border-spacing: 0;
        border-collapse: separate;
    
    td,th {
        white-space: normal;
        overflow-wrap: break-word;
        border-spacing: 0;
        border-collapse: separate;
        padding: 1em;
        padding-left: 3em;
        padding-right: 3em;
        text-align: left;
    }
    .empty-row {
        background-color: #d6d6d6; 
        width: 15%;
    }
    .low-green {
        background-color: #a8bba9; 
        color: #000;
    }
    .low-purple {
        background-color: #BA9EC5;
        color: #000;
    }
    .low-yellow {
        background-color: #D1C294; 
        color: #000;
    }
    
    .ssp-input {
        display: block;
        width: 100%;
        margin: 0 auto; 
        .p-inputnumber {
            width: 100%; 
        }
        input {
            border-radius: 0;
            width: 100%; 
        }
    }
    
    .light-green {
        background-color: #CDE3CC; 
    }

    .pink {
        background-color: #E3C1EE; 
    }

    .light-yellow {
        background-color: #FEEBB4;
    }
`